export default "/images/upload.svg?1020a0aa83f58bcb205328a98107740b";